/*
  Visor ampliado para la galeria de portafolio.

  Se apoya en <dialog> nativo en lugar de un div con clases, porque asi vienen
  gratis y bien hechas tres cosas: cerrar con Escape, atrapar el foco dentro del
  visor mientras esta abierto, y devolver el foco al elemento que lo abrio al
  cerrarlo. Hacer eso a mano es donde suelen fallar los lightbox caseros.

  El disparador es un <button> real, asi que Enter y Espacio funcionan sin
  escuchar teclas por nuestra cuenta.
*/
(function () {
  if (window.__galleryLightboxInit) return;
  window.__galleryLightboxInit = true;

  function abrir(trigger) {
    var root = trigger.closest('[data-gallery-root]');
    if (!root) return;

    var dialog = root.querySelector('[data-gallery-dialog]');
    var target = root.querySelector('[data-gallery-image]');
    var origen = trigger.querySelector('img');
    if (!dialog || !target || !origen || !dialog.showModal) return;

    /* currentSrc y no src: es la resolucion que el navegador eligio de verdad
       del srcset, asi que no se descarga una segunda version distinta. */
    target.src = origen.currentSrc || origen.src;
    target.alt = origen.alt || '';

    dialog.showModal();
    document.documentElement.classList.add('gallery-lightbox-open');
  }

  function cerrar(dialog) {
    if (dialog && dialog.open) dialog.close();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-gallery-open]');
    if (trigger) {
      abrir(trigger);
      return;
    }

    var close = e.target.closest('[data-gallery-close]');
    if (close) {
      cerrar(close.closest('[data-gallery-dialog]'));
      return;
    }

    /* Clic en el fondo: solo cuenta si el objetivo es el propio dialog y no
       algo de su contenido. */
    if (e.target.matches('[data-gallery-dialog]')) {
      cerrar(e.target);
    }
  });

  /* close se dispara tanto por close() como por Escape, asi que el candado del
     scroll se libera en los dos casos con un solo listener. */
  document.addEventListener(
    'close',
    function (e) {
      if (e.target.matches && e.target.matches('[data-gallery-dialog]')) {
        document.documentElement.classList.remove('gallery-lightbox-open');
        var img = e.target.querySelector('[data-gallery-image]');
        if (img) img.removeAttribute('src');
      }
    },
    true
  );
})();
